module.exports = __webpack_public_path__ + "static/media/m-app.cafd4644.webp";